import { createTheme } from "@mui/material/styles";
import { green, red } from "@mui/material/colors";
import "@fontsource/alumni-sans/600.css";
import "@fontsource/poppins/600.css";

// A custom theme for this app
const theme = createTheme({
  spacing: 8,
  cssVariables: true,
  palette: {
    primary: {
      main: "#556cd6",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
    success: {
      main: green.A700,
    },
  },
  typography: {
    fontFamily: "Alumni Sans, Arial, sans-serif",
    body1: {
      fontWeight: 600,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1920,
    },
  },

  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "12px",
          fontFamily: "sans-serif",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: `url('/img/yantra-background.jpg')`,
          userSelect: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          color: "white",
          borderRadius: "0.5rem",
          textTransform: "uppercase",
          fontSize: "1.3rem",
          fontWeight: "600",
          padding: "0.375rem 0.625rem",
          minWidth: "auto",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          "&:last-child": {
            paddingBottom: 0,
          },
        },
      },
    },
  },
});

export default theme;
